@if (template) {
<ng-container *ngTemplateOutlet="template; context: context" />
}